import { render, staticRenderFns } from "./LegoControlCardAuditoria.vue?vue&type=template&id=f0debbfa&scoped=true"
import script from "./LegoControlCardAuditoria.vue?vue&type=script&lang=js"
export * from "./LegoControlCardAuditoria.vue?vue&type=script&lang=js"
import style0 from "./LegoControlCardAuditoria.vue?vue&type=style&index=0&id=f0debbfa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0debbfa",
  null
  
)

export default component.exports